import { gsap } from "gsap";
import { DropShadowFilter } from "pixi-filters";
import { Container, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../common/GameFont";

export class RewardContainer extends Container {
    private rewardIcon: Sprite;
    private rewardValueText: Text;
    private wonText: Text;

    public constructor(icon: Texture, rewardValue: number) {
        super();
        this.rewardIcon = new Sprite(icon);
        this.rewardIcon.anchor.set(0.5, 0.5);
        this.addChild(this.rewardIcon);

        this.rewardValueText = new Text(rewardValue.toString(), new RewardValueTextStyle());
        this.rewardValueText.anchor.set(0.5, 0.5);
        this.rewardValueText.position.set(-281, 25);
        const whiteShadowFilter = new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 15,
            color: 0xFFFCFD,
            quality: 4.2,
            alpha: 0.7
        });
        const purpleShadowFilter = new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 20,
            color: 0xFF2768,
            quality: 4.2,
            alpha: 0.7
        });

        this.rewardValueText.filters = [whiteShadowFilter, purpleShadowFilter, purpleShadowFilter];
        this.addChild(this.rewardValueText);
    }

    public async playStartAnimation(): Promise<void> {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.fromTo(this.rewardIcon.position, { y: this.rewardIcon.position.y - this.rewardIcon.height * 0.8 }, { y: this.rewardIcon.position.y, duration: 0.5 });
        animationTimeLine.fromTo(this.rewardIcon.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.7, ease: "back.out(1)" }, "<50%");
        animationTimeLine.fromTo(this.wonText.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.5, ease: "back.out(2)" }, "<");
        animationTimeLine.fromTo(this.rewardValueText.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.5, ease: "back.out(2)" }, "<20%");
        await animationTimeLine;
        animationTimeLine.kill();
    }

    public async hideContainer(): Promise<void> {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.fromTo(this.rewardIcon.scale, { x: 1, y: 1 }, { x: 0, y: 0, duration: 0.5 }, "<50%");
        animationTimeLine.fromTo(this.wonText.scale, { x: 1, y: 1 }, { x: 0, y: 0, duration: 0.5 }, "<");
        animationTimeLine.fromTo(this.rewardValueText.scale, { x: 1, y: 1 }, { x: 0, y: 0, duration: 0.5 }, "<20%");
        await animationTimeLine;
        animationTimeLine.kill();
    }
}

class RewardValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 287,
            padding: 70
        }));
    }
}
